import { render, staticRenderFns } from "./preset-book-send-edit.component.vue?vue&type=template&id=56bb6158"
import script from "./preset-book-send-edit.component.vue?vue&type=script&lang=ts"
export * from "./preset-book-send-edit.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports